import { RbTable, type RbContextMenuPosition, type RbRowSelectionModel } from '@scmlatam/web-ui';
import type { Position, Row } from '../types/hooks';
import { ToolbarLeft, ToolbarRight } from './Toolbar';
import type { TFunction } from 'i18next';
import type { Dayjs } from 'dayjs';

interface TableProps {
    t: TFunction;
    period: [Dayjs | null, Dayjs | null];
    setPeriod: (period: [Dayjs | null, Dayjs | null]) => void;
    tags: { label: string; value: string; sublabel?: string }[];
    tagSelected: string[];
    setTagSelected: (tags: string[]) => void;
    searchTag: string;
    setSearchTag: (searchTag: string) => void;
    employees: { label: string; value: string; sublabel?: string }[];
    employeeSelected: string[];
    setEmployeeSelected: (employees: string[]) => void;
    searchEmployee: string;
    setSearchEmployee: (searchEmployee: string) => void;
    rowSelected: RbRowSelectionModel;
    setRowSelected: (rows: RbRowSelectionModel) => void;
    loading: boolean;
    columns: any[];
    rows: Row[];
    search: (start_date: string, end_date: string, tags_id__in: string, id_employee__in: string) => Promise<void>;
    reload: () => Promise<void>;
    contextMenu: RbContextMenuPosition | null;
    setContextMenu: (contextMenu: RbContextMenuPosition | null) => void;
    cell: Position | null;
    setCell: (cell: Position | null) => void;
    rowId: string | null;
    setRowId: (rowId: string | null) => void;
    //setOption: (option: Options) => void;
}

const Table = (tableProps: TableProps) => {
    return (
        <div id="schedule-table-view" style={{ display: 'contents' }}>
            <RbTable<Row>
                className="mt-4 w-full"
                toolbarLeft={<ToolbarLeft />}
                toolbarRight={
                    <ToolbarRight
                        t={tableProps.t}
                        period={tableProps.period}
                        setPeriod={tableProps.setPeriod}
                        tags={tableProps.tags}
                        tagSelected={tableProps.tagSelected}
                        setTagSelected={tableProps.setTagSelected}
                        searchTag={tableProps.searchTag}
                        setSearchTag={tableProps.setSearchTag}
                        employees={tableProps.employees}
                        employeeSelected={tableProps.employeeSelected}
                        setEmployeeSelected={tableProps.setEmployeeSelected}
                        searchEmployee={tableProps.searchEmployee}
                        setSearchEmployee={tableProps.setSearchEmployee}
                        loading={tableProps.loading}
                        search={tableProps.search}
                        reload={tableProps.reload}
                    />
                }
                columns={tableProps.columns}
                rows={tableProps.rows}
                showToolbar={true}
                checkboxSelection={true}
                paginate={false}
                defaultRowsPerPage={200}
                emptyText={tableProps.t('table.no_rows')}
                rowSelectionModel={tableProps.rowSelected}
                setRowSelectionModel={tableProps.setRowSelected}
                loading={tableProps.loading}
                density="comfortable"
                size="l"
                onCellContextMenu={(params) => {
                    tableProps.setCell({ x: params.row.id, y: params.field });
                    tableProps.setRowId(params.row.id);

                    tableProps.setContextMenu({
                        x: params.position.x,
                        y: params.position.y,
                    });
                }}
            />
        </div>
    );
};

export { Table };
